import mapRoutes from "./utils";

export default [
  /*
  |--------------------------------------------------------------------------
  | Public Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for public access. These
  | routes do not require authentication and are used by the entire
  | application.
  |
  */

 ...mapRoutes(
  { layout: "clean", public: true, scrollToTop: true },
  [
    {
      path: "/subscriptions-payment/:id/:token/:path/:plan?/:status?",
      name: "subscriptions-payment",
      meta: {
        scrollToTop: true
      },
      component: () =>
        import(
          /* webpackChunckName: 'subscriptions' */ "@/views/SubscriptionWithToken"
        )
    },
    {
      path: "/go-premium/:id/:token/:path/:status?",
      name: "go-premium",
      meta: {
        scrollToTop: true
      },
      component: () =>
        import(
          /* webpackChunckName: 'subscriptions' */ "@/views/GoPremiumWithToken"
        )
    },
    {
      path: "/gift-payment/:id/:token/:profile/:username/:gender/:path",
      name: "gift-payment",
      component: () =>
        import(/* webpackChunkName: 'support' */ "@/views/GiftWithToken")
    }
  ]
),

...mapRoutes({ layout: "default", public: true, scrollToTop: true }, [
    {
      path: "/support",
      name: "support",
      component: () =>
        import(/* webpackChunkName: 'support' */ "@/views/Support")
    },
    {
      path: "/security",
      name: "security",
      component: () =>
        import(/* webpackChunkName: 'security' */ "@/views/Security")
    },
    {
      path: "/colorado-safety-policy",
      name: "colorado-safety-policy",
      component: () =>
        import(/* webpackChunkName: 'colorado-safety-policy' */ "@/views/ColoradoSafetyPolicy")
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () =>
        import(/* webpackChunkName: 'privacy' */ "@/views/Privacy")
    },
    {
      path: "/terms-conditions",
      name: "terms",
      component: () => import(/* webpackChunkName: 'terms' */ "@/views/Terms")
    },
    {
      path: "/guidance",
      name: "guidance",
      component: () =>
        import(/* webpackChunkName: 'guidance' */ "@/views/Guidance")
    },
    {
      path: "/jw-dating",
      name: "jw-dating",
      component: () =>
        import(/* webpackChunkName: 'engagements' */ "@/views/Engagement")
    },
    {
      path: "/conduct",
      name: "conduct",
      component: () =>
        import(/* webpackChunkName: 'conduct' */ "@/views/Conduct")
    },
    {
      path: "/contact-us",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: 'contact' */ "@/views/Contact")
    },
    {
      path: "/stories",
      name: "stories",
      component: () =>
        import(/* webpackChunkName: 'stories' */ "@/views/Stories")
    },
    {
      path: "/story-love/:id",
      name: "storylove",
      component: () =>
        import(/* webpackChunkName: 'stories-love' */ "@/views/StoryLove")
    },
  ]),

  /*
  |--------------------------------------------------------------------------
  | Guest Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for guest access. These
  | routes require not being authenticated and are public
  | access.
  |
  */

  ...mapRoutes(
    { layout: "default", onlyWhenLoggedOut: true, scrollToTop: true },
    [
      {
        path: "/",
        name: "home",
        component: () => import(/* webpackChunkName: 'home' */ "@/views/Home")
      },
      {
        path: "/es",
        name: "home",
        component: () => import(/* webpackChunkName: 'home-es' */ "@/views/Home")
      },
      {
        path: "/login",
        name: "login",
        meta: { isLogin: true },
        component: () => import(/* webpackChunkName: 'home-en' */ "@/views/Home"),
      },
      {
        path: "/register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: 'register' */ "@/views/Register")
      },
      {
        path: "/test_recovery/:token",
        name: "test_recovery",
        component: () =>
          import(/* webpackChunkName: 'recoverytest' */ "@/views/RecoveryTest")
      },
      {
        path: "/password/email/",
        name: "password.reset",
        component: () =>
          import(
            /* webpackChunkName: 'email-password' */ "@/views/PasswordEmail"
          )
      },
      {
        path: "/reset-password/:token/:email",
        name: "password",
        component: () =>
          import(
            /* webpackChunkName: 'reset-password' */ "@/views/PasswordReset"
          )
      },
    ]
  ),

  /*
  |--------------------------------------------------------------------------
  | Protected Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for private access. These
  | routes require authentication and are used for private
  | access.
  |
  */

  ...mapRoutes(
    { layout: "clean", onlyWhenLoggedOut: false, scrollToTop: true },
    [
      {
        path: "/welcome",
        name: "feed",
        component: () => import(/* webpackChunkName: 'feed' */ "@/views/Feed")
      }
    ]
  ),

  ...mapRoutes(
    { layout: "platform", onlyWhenLoggedOut: false, scrollToTop: true },
    [
      {
        path: "/cancel-renewal",
        name: "CancelSubscription",
        component: () => import(/* webpackChunkName: 'CancelSubscription' */ "@/views/CancelSubscripttion")
      },
      {
        path: "/profile/:id",
        name: "profile-detail",
        component: () =>
          import(/* webpackChunkName: 'profile-detail' */ "@/views/Profile")
      },
      {
        path: "/profile/:type?/:status?",
        name: "profile",
        component: () =>
          import(/* webpackChunkName: 'profile' */ "@/views/Profile")
      },
      {
        path: "/profile-edit/:edit",
        name: "profile-edit",
        component: () =>
          import(/* webpackChunkName: 'profile' */ "@/views/Profile")
      },
      {
        path: "/subscriptions/:promos?",
        name: "subscriptions",
        meta: {
          scrollToTop: true
        },
        component: () =>
          import(
            /* webpackChunckName: 'subscriptions' */ "@/views/Subscription"
          )
      },
      {
        path: "/edit-profile",
        name: "editprofile",
        component: () =>
          import(/* webpackChunkName: 'edit-profile' */ "@/views/EditProfile")
      },
      {
        path: "/my-profile",
        name: "myprofile",
        component: () =>
          import(/* webpackChunkName: 'my-profile' */ "@/views/MyProfile")
      },
      {
        path: "/state-subscription",
        name: "statesubscription",
        component: () =>
          import(
            /* webpackChunkName: 'state-subscription' */ "@/views/StateSubscription"
          )
      },
      {
        path: "/renewal-subscription",
        name: "renewal",
        component: () =>
          import(
            /* webpackChunkName: 'renewal-subscription' */ "@/views/RenewalSubscription"
          )
      },
      {
        path: "/favorites",
        name: "favorites",
        component: () =>
          import(/* webpackChunkName: 'favorites' */ "@/views/Favorites")
      },

      {
        path: "/reciprocal-favorites",
        name: "reciprocal",
        component: () =>
          import(
            /* webpackChunkName: 'reciprocal-favorites' */ "@/views/ReciprocalFavorites"
          )
      },
      {
        path: "/invitations",
        name: "invitations",
        component: () =>
          import(/* webpackChunkName: 'invitations' */ "@/views/Invitations")
      },
      {
        path: "/visits",
        name: "visits",
        component: () =>
          import(/* webpackChunkName: 'visits' */ "@/views/Visits")
      },
      {
        path: "/search",
        name: "search",
        component: () => import(/* webpackChunkName: 'search' */ "@/views/Search"),
        props: true
      },
      {
        path: "/messages/:random",
        name: "chat",
        component: () => import(/* webpackChunkName: 'chat' */ "@/views/Chat"),
        props: true
      },
      {
        path: "/share",
        name: "share",
        component: () => import(/* webpackChunkName: 'share' */ "@/views/Share")
      },
      {
        path: "/user/:id",
        name: "user",
        component: () =>
          import(/* webpackChunkName: 'user-profile' */ "@/views/UserProfile")
      },
      {
        path: "/chat",
        name: "UserMessages",
        component: () =>
          import(/* webpackChunkName: 'user-messages' */ "@/views/UserMessages")
      },
      {
        path: "/message",
        name: "messageBody",
        component: () =>
          import(/* webpackChunkName: 'message-body' */ "@/views/MessagesBody")
      },
      {
        path: "/verify-phone",
        name: "verifyPhone",
        component: () =>
          import(/* webpackChunkName: 'verify-phone' */ "@/views/VerifyPhone")
      },
      {
        path: "/blocked-profile",
        name: "blockedProfile",
        component: () =>
          import(
            /* webpackChunkName: 'blocked-profile' */ "@/views/BlockedProfile"
          )
      },
      {
        path: "/complaints/:id?",
        name: "complaints",
        component: () =>
          import(/* webpackChunkName: 'complaints' */ "@/views/Complaints")
      },
      {
        path: "/create-story",
        name: "CreateStory",
        component: () =>
          import(/* webpackChunkName: 'create-story' */ "@/views/CreateStory")
      },
    ]
  ),

  ...mapRoutes({ layout: "platform", public: true }, []),

  /*
  |--------------------------------------------------------------------------
  | Error Routes
  |--------------------------------------------------------------------------
  |
  | Here is where you can register routes for error messages. These
  | routes are used when there is no match.
  |
  */

  ...mapRoutes({ layout: "default", public: true, scrollToTop: true }, [
    {
      path: "*",
      name: "404",
      component: () =>
        import(/* webpackChunkName: '404' */ "@/views/errors/404")
    }
  ])
];
